module.exports = '<svg width="34" height="32" viewBox="0 0 34 32"><path d="M33.681 11.488A2.127 2.127 0 0 0 32 10.667h-2.948L25.551 3.67c.023-.156.049-.309.049-.469 0-1.766-1.434-3.2-3.2-3.2s-3.2 1.434-3.2 3.2a3.188 3.188 0 0 0 2.935 3.172l2.146 4.294H9.851l2.146-4.294a3.189 3.189 0 0 0 2.935-3.172c0-1.766-1.434-3.2-3.2-3.2s-3.2 1.434-3.2 3.2c0 .16.026.314.047.469L5.08 10.667H2.132c-.659 0-1.278.303-1.681.821a2.13 2.13 0 0 0-.39 1.828l4.267 17.067A2.136 2.136 0 0 0 6.399 32h21.333c.979 0 1.833-.666 2.071-1.617l4.267-17.067a2.13 2.13 0 0 0-.39-1.828z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/basket-2.js
// module id = 997
// module chunks = 14